/**
 * edit_voraussichtlicheErntetermine
 * @returns {boolean}
 * @param requestUri
 */
window.edit_voraussichtlicheErntetermine = function (requestUri) {
    window.location = '/vegetationErnte/voraussichtlicheErntetermine?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_geschaetzteErtraege
 * @returns {boolean}
 */
window.edit_geschaetzteErtraege = function (requestUri) {
    window.location = '/vegetationErnte/geschaetzteErtraege?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_bluehbeginn
 * @returns {boolean}
 * @param requestUri
 */
window.edit_bluehbeginn = function (requestUri) {
    window.location = '/vegetationErnte/bluehbeginn?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_bluehende
 * @returns {boolean}
 * @param requestUri
 */
window.edit_bluehende = function (requestUri) {
    window.location = '/vegetationErnte/bluehende?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_ernte
 * @returns {boolean}
 * @param requestUri
 */
window.edit_ernte = function (requestUri) {
    window.location = '/vegetationErnte/ernte?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_herbizidflaeche
 * @returns {boolean}
 * @param requestUri
 */
window.edit_herbizidflaeche = function (requestUri) {
    window.location = '/betriebsdaten/herbizidflaeche?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_arbeitsmittel
 * @param requestUri
 * @returns {boolean}
 */
window.edit_arbeitsmittel = function (requestUri) {
    window.location = '/betriebsdaten/arbeitsmittel?uriBefore=' + requestUri;
    return false;
};

/**
 * edit_mitarbeiter
 * @param requestUri
 * @returns {boolean}
 */
window.edit_mitarbeiter = function (requestUri) {
    window.location = '/betriebsdaten/betriebsleiterMitarbeiter?uriBefore=' + requestUri;
    return false;
};

/**
 * go to record
 * @param requestUri
 * @param category
 * @param recordID
 * @returns {boolean}
 */
window.gotToAufzeichnung = function (requestUri, category, recordID) {
    window.location = BASE_PATH + 'aufzeichnungen/' + category + '/' + recordID + '?step=3&uriBefore=' + requestUri;
    return false;
};